import styled, { keyframes } from "styled-components";
import { MainColor } from "../variable/variable";
interface ButtonCoreProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

// animation xoay spinner
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
export const ButtonCore = styled.button`
  margin: 0 1em;
  height: 32px;
  padding: 4px 15px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background-color: ${MainColor};
  cursor: pointer;
  font-weight: 600;
`;

export const PaddingDiv = styled.div`
  padding: 0.5rem 0;
`;
export const ButtonCoreWithLoading = styled(ButtonCore)<ButtonCoreProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:disabled {
    cursor: not-allowed;
  }

  .spinner {
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid #fff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    animation: ${spin} 0.8s linear infinite;
    margin-right: 8px;
  }
`;
